import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('comment');

export function getGoodsCommentCount(conditions) {
  return jrequest('count', conditions);
}

export function getGoodsComment(conditions) {
  return jrequest('list', conditions);
}

export function addComment(conditions) {
  return jrequest('add', conditions, { method: 'post' });
}
